import { format } from 'date-fns-tz/format';

export function formatGameDate(date: string | Date) {
  return format(date, 'ccc, MMM d, h:mm aa (z)');
}

export function formatPregameTime(date: string | Date) {
  return format(date, 'h:mm aa (z)');
}

export function formatYearMonthDay(date: string | Date) {
  return format(date, 'yyyy-MM-dd');
}

export function formatYearMonthDayHourMinuteSecond(date: string | Date) {
  return format(date, 'yyyy-MM-dd HH:mm:ss');
}

export function formatHourMinute(date: string | Date) {
  return format(date, 'HH:mm');
}

export function formatHourMinuteSecond(date: string | Date) {
  return format(date, 'HH:mm:ss');
}

export function formatFullDateAndTimeUTC(date: string | Date) {
  return format(date, "EEEE MMMM do, yyyy h:mm a '(UTC)'");
}

export function formatFullDateUtc(date: string | Date) {
  return format(date, "EEEE MMMM do, yyyy '(UTC)'");
}

export function formatWeekdayMonthDayHourMinuteSecond(date: string | Date) {
  return format(date, 'E, MMM d, h:mm:ss a (z)');
}

export function formatWeekdayMonthDayHourMinute(date: string | Date) {
  return format(date, 'E, MMM d, h:mm a (z)');
}

export function formatMonthDayYearHourMinuteSecond(date: string | Date) {
  return format(date, 'MM/dd/yyyy hh:mm:ss a (z)');
}

export function formatMilliseconds(date: string | Date) {
  return format(date, 'T');
}

export const formatTimestamp = (timestamp: string | null | undefined): string => {
  return timestamp ? format(timestamp, 'MM/dd/yyyy hh:mm:ss aa (z)') : '';
};
